import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { STATIC_PATH } from '../../config';

const AFFILIATE_LINK = '/offers/all';
const BANNER_IMAGE = `${STATIC_PATH}/img/dashboard-banners/default/banner-affiliate.jpg`;
const HIDE_BANNER_KEY = 'hide_banner_widget';

const BannerWidget = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isBannerHidden = localStorage.getItem(HIDE_BANNER_KEY) === 'true';
    setIsVisible(!isBannerHidden);
  }, []);

  const handleClose = () => {
    localStorage.setItem(HIDE_BANNER_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="banner-widget">
      <button className="banner-close" type="button" onClick={handleClose} />
      <Link to={AFFILIATE_LINK} target="_blank">
        <img src={BANNER_IMAGE} alt="Banner" />
      </Link>
    </div>
  );
};

export default BannerWidget;
